var query = window.location.hostname;
if(query.indexOf( "ciic.com.cn")>-1) {
  alert("尊敬的用户，您好！\n" +
    "为进一步规范中智集团网站名称及域名，中智薪税公司中智薪税云已更换域名https://hrms.ciicpt.com.cn ，请注意保存。旧域名将于2021-05-31日起暂停使用。\n");
  window.location.href = "https://hrms.ciicpt.com.cn";
}

export default {

  // HRCLOUD_URL: process.env.VUE_APP_HRCLOUD_APP_BASE_URL + process.env.VUE_APP_HRCLOUD_APP_BASE_API,   //通过ip访问人事云的地址
  HRCLOUD_URL: process.env.VUE_APP_HRCLOUD_DOMAIN_URL + process.env.VUE_APP_HRCLOUD_DOMAIN_BASE_API,   //通过域名访问人事云的地址
  //Report_Cli_URL: process.env.VUE_APP_REPORT_DOMAIN_URL + process.env.VUE_APP_REPORT_APP_BASE_API ,   //通过ip访问报表工具的地址
  Report_Cli_URL: process.env.VUE_APP_REPORT_DOMAIN_URL + process.env.VUE_APP_REPORT_DOMAIN_BASE_API ,   //通过域名访问报表工具的地址
  // Report_Cli_URL : "http://192.168.251.62:9093/"
}


